export const NoOrganizationSelected = () => {
  return (
    <div className="flex items-center justify-center h-full text-base-content/50">
      <p>Организация не выбрана</p>
    </div>
  )
}

